<template>
  <FormSelect
    :disabled="disabled"
    :loading="loading"
    :name="$t('meta.fraction')"
    :options="fractionOptions"
    :required="required"
    :value="value"
    @input="$emit('input', $event)"
  />
</template>

<script>
import FormSelect from '@/components/Form/Select/index.vue'

import fractionsApi from '@/api/companies/fractions'

export default {
  name: 'FractionSelect',
  components: { FormSelect },
  data: () => ({
    fractions: null,
    loading: true,
  }),
  props: {
    value: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    companyUuid: { type: String, default: null },
    selectableInOrders: { type: Boolean, default: false },
    zoneUuid: { type: String, default: null },
  },
  computed: {
    fractionOptions() {
      return this.fractions?.map(fraction => ({
        label: fraction.localized_name,
        value: fraction.uuid,
      }))
    },
    combinedParams() {
      return [this.companyUuid, this.zoneUuid]
    },
  },
  watch: {
    // If either companyUuid or zoneUuid changes, reload the fractions
    combinedParams: {
      immediate: true,
      async handler() {
        await this.loadData()
      },
    },
  },
  methods: {
    async loadData() {
      if (this.companyUuid) {
        const params = {}

        if (this.selectableInOrders) {
          params['selectable_in_orders'] = true
        }

        if (this.zoneUuid) {
          params['zone_uuid'] = this.zoneUuid
        }

        this.fractions = await fractionsApi.getAll(this.companyUuid, params)
      } else {
        this.fractions = []
      }

      this.loading = false
    },
  },
}
</script>
